/* ============================================================
   Jagdish Store — In-Home Design Service booking form

   CHANGED 9 September 2026 — the visit is FREE.

   This file used to add the Rs 500 booking product to the cart
   and redirect to the Shopify checkout so PayU could take the
   money. The visit no longer costs anything, so all of that is
   gone: no cart/add.js, no cart/update.js, no checkout URL, no
   PayU link, no variant id.

   What is left is the part that was always worth keeping — the
   validation, the friendly error messages, the scroll-to-first-
   mistake, and the pressed state on the button. When everything
   is valid the browser submits Shopify's own contact form, which
   emails every answer to the store.
   ============================================================ */
(function () {
  'use strict';

  var MANDATORY = 'This field is mandatory. Please fill it in.';

  function init(root) {
    if (!root || root.dataset.jdsReady === '1') return;
    root.dataset.jdsReady = '1';

    /* After a successful send Shopify re-renders the section with the
       thank-you panel in place of the fields. Move focus to it so a
       screen-reader user is told the booking went through. */
    var thanks = root.querySelector('[data-jds-thanks]');
    if (thanks) {
      try { thanks.focus({ preventScroll: true }); } catch (err) {}
      return;
    }

    var form = root.querySelector('form');
    if (!form) return;

    var submitBtn = form.querySelector('[data-jds-submit]');
    var termsBox = form.querySelector('[data-jds-terms]');
    var termsWrap = form.querySelector('[data-jds-terms-wrap]');
    var status = form.querySelector('[data-jds-status]');
    var bodyField = form.querySelector('[data-jds-body]');
    var submitLabel = submitBtn ? submitBtn.textContent : 'Book my visit';

    function val(name) {
      var el = form.querySelector('[data-field="' + name + '"]');
      return el ? (el.value || '').trim() : '';
    }

    /* --- Fill-on-tap for the button (parity with mouse hover) --- */
    if (submitBtn) {
      ['touchstart', 'pointerdown', 'mousedown'].forEach(function (evt) {
        submitBtn.addEventListener(evt, function () {
          submitBtn.classList.add('is-pressed');
        }, { passive: true });
      });
      ['touchend', 'touchcancel', 'pointerup', 'pointercancel', 'mouseup', 'mouseleave', 'blur'].forEach(function (evt) {
        submitBtn.addEventListener(evt, function () {
          window.setTimeout(function () {
            if (submitBtn.getAttribute('aria-busy') !== 'true') {
              submitBtn.classList.remove('is-pressed');
            }
          }, 160);
        }, { passive: true });
      });
    }

    /* --- Anything marked data-jds-scroll jumps down to the form --- */
    var scrollers = root.querySelectorAll('[data-jds-scroll]');
    Array.prototype.forEach.call(scrollers, function (el) {
      el.addEventListener('click', function (e) {
        var target = document.getElementById('jds-booking-form');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var first = target.querySelector('input:not([type=hidden]), select, textarea');
        if (first) {
          window.setTimeout(function () {
            try { first.focus({ preventScroll: true }); } catch (err) {}
          }, 500);
        }
      });
    });

    function say(message) {
      if (status) status.textContent = message || '';
    }
    function clearError(field) {
      var wrap = field.closest('.jds-field');
      if (wrap) wrap.classList.remove('is-error');
    }
    function markError(field, message) {
      var wrap = field.closest('.jds-field');
      if (!wrap) return;
      wrap.classList.add('is-error');
      var msg = wrap.querySelector('.jds-field__error');
      if (msg) msg.textContent = message;
    }

    var allFields = form.querySelectorAll('input, select, textarea');
    Array.prototype.forEach.call(allFields, function (field) {
      field.addEventListener('input', function () { clearError(field); });
      field.addEventListener('change', function () { clearError(field); });
    });

    if (termsBox && termsWrap) {
      termsBox.addEventListener('change', function () {
        if (termsBox.checked) {
          termsWrap.classList.remove('is-error');
          say('');
        }
      });
    }

    function goTo(el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(function () {
        try { el.focus({ preventScroll: true }); } catch (err) {}
      }, 450);
    }

    function validate() {
      var firstBad = null;
      var firstBadMsg = '';
      var required = form.querySelectorAll('[data-required]');

      Array.prototype.forEach.call(required, function (field) {
        var value = (field.value || '').trim();
        var message = '';

        if (!value) {
          message = MANDATORY;
        } else if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
          message = 'Please enter a valid email address.';
        } else if (field.getAttribute('data-validate') === 'phone' && !/^[6-9][0-9]{9}$/.test(value.replace(/[^0-9]/g, '').slice(-10))) {
          message = 'Please enter a valid 10-digit mobile number.';
        } else if (field.getAttribute('data-validate') === 'pincode' && !/^[1-9][0-9]{5}$/.test(value)) {
          message = 'Please enter a valid 6-digit pincode.';
        }

        if (message) {
          markError(field, message);
          if (!firstBad) { firstBad = field; firstBadMsg = message; }
        } else {
          clearError(field);
        }
      });

      if (firstBad) {
        say(firstBadMsg === MANDATORY ? 'Please fill in all the mandatory fields marked in red.' : firstBadMsg);
        goTo(firstBad);
        return false;
      }

      if (termsBox && !termsBox.checked) {
        if (termsWrap) termsWrap.classList.add('is-error');
        say('Please tick the box to confirm you have read the terms.');
        goTo(termsBox);
        return false;
      }

      say('');
      return true;
    }

    /* Shopify lists every contact[...] field in the email, but a plain
       readable summary in the message body saves the office reading a
       table. Built here, just before the form is allowed to submit. */
    function buildBody() {
      if (!bodyField) return;
      var lines = ['IN-HOME DESIGN VISIT — free booking request', ''];
      var propFields = form.querySelectorAll('[data-prop]');
      Array.prototype.forEach.call(propFields, function (field) {
        var value = (field.value || '').trim();
        if (!value) return;
        lines.push(field.getAttribute('data-prop') + ': ' + value);
      });
      if (termsBox && termsBox.checked) {
        lines.push('Terms accepted: Yes');
      }
      lines.push('');
      lines.push('No payment was taken. This visit is free.');
      bodyField.value = lines.join('\n');
    }

    form.addEventListener('submit', function (e) {
      if (!validate()) {
        e.preventDefault();
        return;
      }

      buildBody();

      if (submitBtn) {
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.classList.add('is-pressed');
        submitBtn.textContent = 'Sending your booking...';
      }
      say('Sending your booking...');

      /* No preventDefault — the browser now posts Shopify's contact form,
         which emails the store and returns to this page with the
         thank-you panel showing. */
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-jds-root]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-jds-root]') : null;
    if (root) init(root);
  });
})();
